<template>
    <el-dialog
            class="detail-info-dia"
            :title="title"
            :visible.sync="isShow"
            :close-on-click-modal="false"
            :width="dw"
            top="12vh">
        <div class="main_con">
            <vue-scroll :ops="ops" ref="vs">
        <el-form :model="punishPeople" label-width="120px" class="blackListForm" :rules="formRules" ref="form">
            <el-form-item label="姓名"  prop="name">
                <el-input placeholder="请输入姓名" :disabled="notEdit" v-model.trim="punishPeople.name"></el-input>
            </el-form-item>
            <el-form-item label="证件号" prop="id_number" :rules="[{required: true,message:'请输入身份有效证件号',trigger:'blur'}]">
                <el-input placeholder="请输入证件号" disabled  v-model.trim="punishPeople.id_number"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input :placeholder="notEdit ? '暂无手机号' : '请输入手机号'" :disabled="notEdit"  v-model.trim="punishPeople.mobile_phone"></el-input>
            </el-form-item>
            <el-form-item label="处罚类型" prop="type">
                <el-select v-model="punishPeople.type"
                  style="width: 100%"
                  placeholder="请选择处罚类型"
                  disabled>
                    <el-option
                      v-for="(item, index) in punish_type_list"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item >
            <el-form-item label="处罚依据" prop="punish_basis">
                <el-cascader
                  style="width:320px;overflow-wrap: break-word"
                  placeholder="选择处罚依据"
                  propper-class="my-wrapper"
                  :options="optionsListSelect"
                  :disabled="notEdit"
                  :props="{ multiple: true }"
                  v-model="punishPeople.punish_basis"
                  :title="punishPeople.punish_basis"
                  filterable></el-cascader>
            </el-form-item>
            <el-form-item label="处罚建议" prop="punish_suggest">
                <el-cascader
                  style="width:320px;overflow-wrap: break-word"
                  placeholder="选择处罚建议"
                  propper-class="my-wrapper"
                  :options="optionsSuggest"
                  :disabled="notEdit"
                  :props="{ multiple: true }"
                  v-model="punishPeople.punish_suggest"
                  :title="punishPeople.punish_suggest"
                  filterable></el-cascader>
            </el-form-item>
            <el-form-item label="处罚证明材料"   class="up-form-item" v-if="notEdit">
                <template v-if="punishPeople.document_list.length>0">
                    <div v-for="(document, index) in punishPeople.document_list" :key="index">
                        <p  style="color: #4cd964"><a :href="document.url" target="_blank">{{document.name ? document.name : '（点击查看失信名单材料）'}}</a></p>
                    </div>
                </template>
                <template v-else>
                    <p>（暂无）</p>
                </template>

            </el-form-item>
            <el-form-item label="处罚证明材料（假证书、处罚通知等）"  style="padding-left: 20px" label-width="100px"  class="up-form-item" v-else>
                <div class="upfile-wrap" style="position: relative">
                    <el-upload
                      ref="uploadFile"
                      action="/api/enroll/upload_enroll_file.json"
                      :file-list="punishPeople.document_list"
                      :headers="fileUpHeaders"
                      :data="fileUpParam"
                      :before-upload="beforeUpload"
                      :on-progress="isUping"
                      :on-error="uploadError"
                      :on-success="uploadSuccess"
                      :on-remove="fileRemove"
                    >
                        <el-button type="primary" style="position: absolute;top: 40px;left: 3px;">点击上传</el-button>
                        <p class="tip">支持jpg,jpeg,png,pdf格式的文件，且大小不能超过15MB</p>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item label="说明" prop="remark">
                <el-row style="position: relative">
                    <el-input type="textarea" :disabled="notEdit" rows="3" maxlength="500" style="width: 100%" :placeholder="notEdit  ? '暂无说明' : '为了方便后续查询，请您简要输入该处罚产生的原因。例如：XX比赛中该教练员出现了谩骂或殴打裁判员等情况'" v-model="punishPeople.remark"></el-input>
                    <span  v-if="!notEdit" class="num" style="position: absolute;bottom: -10px;right: 10px">{{punishPeople.remark.length}}/500</span>
                </el-row>
            </el-form-item>
            <div class="btns" v-if="!notEdit">
                <el-button type="primary" @click="sureSubmit" :loading="loading" :disabled="loading">提交</el-button>
                <el-button type="danger" @click="cancel">取消</el-button>
            </div>
        </el-form>
            </vue-scroll>
        </div>
    </el-dialog>
</template>

<script>
    import {punish_type_list} from "@/assets/js/select";
    import {viewPunishInfo,editPunishPeople} from "@/api/agency/agency";
    import formRules from '@/minix/BlackList';
    import ops from "@/assets/js/vuescrollOption";
    import { storageData } from "@/assets/js/storage";
    import fiveMixins from "@/minix/fiveMixins";
    export default {
        name: "edit_and_look_blackList",
        mixins:[formRules,fiveMixins],
        data(){
            return{
              punish_type_list,
                loading:false,
                ops:ops(true),
              fileUpHeaders: { "X-Token": storageData.getToken(),"X-UserType":storageData.getUserType() },
              fileUpParam: {},
              submitDisabled: false,
              options: [{
                value: '《教练员培训管理规定》（2023版）第九十八条',
                label: '《教练员培训管理规定》（2023版）第九十八条',
                children: [{
                  value: '（一）违反国家法律法规',
                  label: '（一）违反国家法律法规',
                }, {
                  value: '（二）违反国际足联、亚足联及其他洲际足球协会的相关管理规定并被处罚',
                  label: '（二）违反国际足联、亚足联及其他洲际足球协会的相关管理规定并被处罚',
                },{
                  value: '（三）违反《中国足球协会章程》等本会其他规范性文件规定',
                  label: '（三）违反《中国足球协会章程》等本会其他规范性文件规定',
                },{
                  value: '（四）违反中国足协会员协会关于教练员培训的相关规范性文件规定',
                  label: '（四）违反中国足协会员协会关于教练员培训的相关规范性文件规定',
                },{
                  value: '（五）违反中国足协及其会员协会主办的各级各类足球比赛的赛风赛纪、反兴奋剂管理规定并被纪律处罚',
                  label: '（五）违反中国足协及其会员协会主办的各级各类足球比赛的赛风赛纪、反兴奋剂管理规定并被纪律处罚',
                },{
                  value: '（六）违反中国足协颁布的关于教练员培训的其他规定文件',
                  label: '（六）违反中国足协颁布的关于教练员培训的其他规定文件',
                },{
                  value: '（七）参与违规',
                  label: '（七）参与违规',
                }]
              }],
              optionsSuggest: [{
                value: '《教练员培训管理规定》（2023版）第九十九条',
                label: '《教练员培训管理规定》（2023版）第九十九条',
                children: [{
                  value: '（一）拒绝其报名参加各级各类教练员培训的申请并报中国足协备案',
                  label: '（一）拒绝其报名参加各级各类教练员培训的申请并报中国足协备案',
                }, {
                  value: '（二）取消其参加低级别教练员培训和继续教育培训资格 3 至 36 个月并报中国足协备案',
                  label: '（二）取消其参加低级别教练员培训和继续教育培训资格 3 至 36 个月并报中国足协备案',
                },{
                  value: '（三）向中国足协申请取消其参加高级别教练员培训和继续教育培训资格 3 至 36 个月',
                  label: '（三）向中国足协申请取消其参加高级别教练员培训和继续教育培训资格 3 至 36 个月',
                },{
                  value: '（四）向中国足协申请暂停其教练员执教执照 3 至 36 个月',
                  label: '（四）向中国足协申请暂停其教练员执教执照 3 至 36 个月',
                },{
                  value: '（五）向中国足协申请取消其教练员证书和执教执照，且 36 个月内不得报名参加中国足协教练员培训课程',
                  label: '（五）向中国足协申请取消其教练员证书和执教执照，且 36 个月内不得报名参加中国足协教练员培训课程',
                },{
                  value: '（六）向中国足协申请永久取消其教练员证书和执教执照，且不得报名参加中国足协教练员培训课程',
                  label: '（六）向中国足协申请永久取消其教练员证书和执教执照，且不得报名参加中国足协教练员培训课程',
                },{
                  value: '（七）向中国足协申请永久取消其教练员证书和执教执照，且禁止其从事教练员相关工作',
                  label: '（七）向中国足协申请永久取消其教练员证书和执教执照，且禁止其从事教练员相关工作',
                }]
              }],
              punishPeople:{
                name:'',
                mobile_phone:'',
                id_number:'',
                type:'',
                punish_basis:'',
                punish_suggest:'',
                remark:'',
                document_list: [],
              },
            }
        },
      created(){
        let {punish_id} = this.Info;
        viewPunishInfo({punish_id:punish_id}).then(({data:{status, result}}) => {
          if(Number(status) === 0){
            const documents = result.documentList.map(item => ({
              url: item.document_address,
              document_id: item.document_id,
              name: item.document_title
            }))
            this.$set(this.punishPeople,"document_list",documents);
            let { punish_basis,punish_suggest, ...rest} = result.punishPeople;
            this.punishPeople = Object.assign({}, this.punishPeople, rest)
            this.punishPeople.punish_basis = result.punishPeople.punish_basis ? JSON.parse(result.punishPeople.punish_basis) : '';
            this.punishPeople.punish_suggest = result.punishPeople.punish_suggest ? JSON.parse(result.punishPeople.punish_suggest) : '';
          }
        })
      },
        props:{
            showBlackListDialog:{
                type:Boolean,
                required:true,
                default: false,
            },
            title:{
                type:String,
                default:'处罚人员详情'
            },
            Info:{
                type:Object,
                required :false
            },
            notEdit:{
                type:Boolean,
                default:true, //默认是查看
            },
            dw:{
                default:'500px',
                required:false,
            }
        },
        computed: {
            isShow: {
                get(){
                    return this.showBlackListDialog;
                },
                set(bool){
                    // 参数1：是否显示弹窗
                    // 参数2：是否点击确定按钮
                    this.$emit("hideTipsPunish", bool, false);
                }
            },
          optionsListSelect() {
            if(this.isFive) {
              return this.optionsFive
            } else {
              return this.options
            }
          },
        },
        methods:{
          beforeUpload(file) {
            if (file.size > 15 * 1024 * 1024) {
              this.$message.error("文件大小不能超过15M!");
              return false;
            }
            if (!/^.*\.(jpg|png|jpeg|pdf)$/i.test(file.name)) {
              this.$message.error("请上传 jpg png jpeg pdf 格式的文件!");
              return false;
            }
            let param = {
              document: file
            };
            for (const key in param) {
              if (param.hasOwnProperty(key)) {
                this.$set(this.fileUpParam, key, param[key]);
              }
            }
          },
          isUping() {
            this.submitDisabled = true;
          },
          uploadError() {
            this.submitDisabled = false;
          },
          uploadSuccess(res) {
            this.submitDisabled = false;
            if (Number(res.status) === 0) {
              this.punishPeople.document_list.push({ url: res.result.document_url, name: res.result.document_name })
            } else {
              this.$nextTick(() => { });
              this.$message.error(res.msg);
            }
          },
          fileRemove(file, fileList) {
            this.punishPeople.document_list = fileList;
          },
            cancel(){
                this.isShow=false;
            },
            sureSubmit(){
                this.$refs["form"].validate((valid) => {
                    if (valid){
                        this.loading=true;
                        const { punish_basis,punish_suggest, document_list, ...rest}=this.punishPeople
                      editPunishPeople({
                          ...rest,
                          document_list: JSON.stringify(document_list.map(item => ({
                            url: item.url,
                            name: item.name,
                            document_id: item.document_id || '',
                          }))),
                          punish_basis:JSON.stringify(punish_basis),
                          punish_suggest:JSON.stringify(punish_suggest),
                        punish_status:"audit"
                        }).then(res=>{
                            if (res.data.status===0){
                                this.loading=false;
                                this.$emit("hideTipsPunish", false, true);
                            }else{
                                this.$message.error(res.data.msg)
                                this.loading=false
                            }
                        }).catch(error=>{
                            this.loading=false
                        })
                    } else{
                        this.$message.error('请填写所有带*号的必填项')
                    }
                })

            },
        },
        components:{
            "image-up": () => import("@/components/UpImage/UpImage"),
        }
    }
</script>

<style scoped lang="stylus">
    .main_con
        height 600px
    .blackListForm
        padding-right 20px
        .btns
            display flex
            justify-content: center
    .tip
        position absolute
        top 45px
        right 13px
        width 188px
        text-align left
        line-height 1.2


</style>

<style lang="stylus">
    .upfile-wrap
        .el-upload-list
            margin-top 45px
    .el-cascader-node
        line-height:15px
</style>
